export function money(amount, symbol = "₹") {
  const n = Number(amount || 0);
  const loc = symbol === "₹" ? "en-IN" : "en-US";
  return `${symbol}${n.toLocaleString(loc, { maximumFractionDigits: 2 })}`;
}

export function symbolOf(item) {
  return item?.currency_symbol || item?.symbol || "₹";
}
